export const setCode = 'setCode'
export const setShowSideBar = 'setShowSideBar'
export const setShowCode = 'setShowCode'
export const setPhoneMode = 'setPhoneMode'
export const setDisplayWidth = 'setDisplayWidth'
export const setLanguage = 'setLanguage'
export const setLanguageCallback = 'setLanguageCallback'
export const setLanguagePopupData = 'setLanguagePopupData'
export const setUserInfo = 'setUserInfo'
export const setProject = 'setProject'
export const setDevices = 'setDevices'
export const setMyDevices = 'setMyDevices'
export const setDevice = 'setDevice'
export const setTabs = 'setTabs'
export const setFilteredTabs = 'setFilteredTabs'
export const setIsAdmin = 'setIsAdmin'
export const setIsModified = 'setIsModified'
export const setIsPublish = 'setIsPublish'
export const setBlocklyXml = 'setBlocklyXml'
export const setLoginData = 'setLoginData'
export const setUserPopupData = 'setUserPopupData'
export const setPasswordPopupData = 'setPasswordPopupData'
export const setLeavePopupData = 'setLeavePopupData'
export const setInfoPopupData = 'setInfoPopupData'
export const setEmailVerificationPopupData = 'setEmailVerificationPopupData'
export const setMessagePopupData = 'setMessagePopupData'
export const setConfirmPopupData = 'setConfirmPopupData'
export const setOpenProjectPopupData = 'setOpenProjectPopupData'
export const setSaveProjectPopupData = 'setSaveProjectPopupData'
export const setRenameProjectPopupData = 'setRenameProjectPopupData'
export const setUrlEditProjectPopupData = 'setUrlEditProjectPopupData'
export const setProjectDetailPopupData = 'setProjectDetailPopupData'
export const setAddDevicePopupData = 'setAddDevicePopupData'
export const setHelpPopupData = 'setHelpPopupData'

export default {
  setCode,
  setShowSideBar,
  setShowCode,
  setPhoneMode,
  setDisplayWidth,

  setLanguage,
  setLanguageCallback,
  setLanguagePopupData,

  setUserInfo,
  setProject,
  setDevices,
  setMyDevices,
  setDevice,
  setTabs,
  setFilteredTabs,
  setIsAdmin,
  setIsModified,
  setIsPublish,
  setBlocklyXml,
  setLoginData,
  setUserPopupData,
  setPasswordPopupData,
  setLeavePopupData,
  setInfoPopupData,
  setEmailVerificationPopupData,
  setMessagePopupData,
  setConfirmPopupData,

  setOpenProjectPopupData,
  setSaveProjectPopupData,
  setRenameProjectPopupData,
  setUrlEditProjectPopupData,
  setProjectDetailPopupData,
  setAddDevicePopupData,
  setHelpPopupData
}
